import { render, staticRenderFns } from "./ConfigCabinets.vue?vue&type=template&id=6be8ea68&scoped=true"
import script from "./ConfigCabinets.vue?vue&type=script&lang=ts"
export * from "./ConfigCabinets.vue?vue&type=script&lang=ts"
import style0 from "./ConfigCabinets.vue?vue&type=style&index=0&id=6be8ea68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8ea68",
  null
  
)

export default component.exports